import { Injectable } from '@angular/core';
import { each, some } from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class PlaybookAddRowColumnService {


  addRowAndBlockToColumn(column, referenceRow, correctRowId, contType, pos, container, sectionIdTab, movedContentBlockId, playbookId, pageTemplateId, movedData) {
    let sectionId;
    const row = {
      contentColumnId: column.id,
      playbookId,
      movedContentBlockId,
      order: null,
      type: contType
    };
    if (referenceRow) {
      switch (pos) {
        case 'top':
          row.order = referenceRow.order;
          break;
        case 'bottom':
          row.order = referenceRow.order + 1;
      }
    } else {
      row.order = 0;
    }
    each(column.contentRows, (item) => {
      if ((pos == 'top' && item && referenceRow && item.order >= referenceRow.order) ||
        (pos == 'bottom' && item && referenceRow && item.order > referenceRow.order)) {
        item.order = item.order + 1;
      }
    });
    sectionId = column.containerId;
    if (sectionId == null) {
      sectionId = sectionIdTab;
    }
    return {
      uri: `/api/ContentRows`,
      object: {
        playbookId,
        contentColumnId: row.contentColumnId,
        movedContentBlockId: row.movedContentBlockId,
        ...(movedData && movedData.isRowMoving && { movedContentRowId: movedContentBlockId }),
        type: contType,
        order: row.order,
        pageTemplateId
      },
      data: column
    };
  }
  addColumnToRowMoveRow(container, row, column, position, type, tElement, tabHeaders, movedContentBlockId, pageTemplateId = null) {
    const nColumn = {
      contentRowId: row.id,
      playbookId: column.playbookId,
      movedContentBlockId,
      order: (position == 'left') ? 0 : 1
    };

    let sectionId;
    let pageId;
    if (tElement) {
      sectionId = tabHeaders.sectionId;
      pageId = tabHeaders.pageId;
    } else {
      sectionId = container.id;
      pageId = container.parentContainerId;
    }
    return {
      uri: `/api/ContentColumns/AddColumnToRowMoveRow`,
      object: {
        playbookId: nColumn.playbookId,
        contentRowId: nColumn.contentRowId,
        containerId: container.id,
        type,
        contentColumnId: column.id,
        order: nColumn.order,
        columnWidth: 50,
        movedContentBlockId: nColumn.movedContentBlockId,
        pageTemplateId
      },
      api: 0
    };
  }

  addColumnRowAndBlockToRow(container, row, column, position, type, tElement, tabHeaders, videoblock, movedContentBlockId, pageTemplateId = null) {
   
    if (column.containerId) {
      let pContainer;
      if (container.id == column.containerId) {
        pContainer = container;
      }

      // only has 1 column, so we need to move stuff around
      if (container && row && column.containerId == container.id) {
        // tslint:disable-next-line: max-line-length
        return this.addColumnToRowMoveRow(container, row, column, position, type, tElement, tabHeaders, movedContentBlockId, pageTemplateId);
      }
    } else if (column.contentRowId) {
      // dealing with a row level column
      // get parent row
      let sectionId;
      let pageId; 
      if (tElement) {     // if tabs
        sectionId = tabHeaders.sectionId;
        pageId = tabHeaders.pageId;
      } else {
        sectionId = container.id;
        pageId = container.parentContainerId;
      }
      const nColumn = {
        contentRowId: column.contentRowId,
        playbookId: column.playbookId,
        movedContentBlockId,
        order: (position == 'left') ? column.order : column.order + 1
      };

      return {
        uri: `/api/ContentColumns`,
        object: {
          playbookId: nColumn.playbookId,
          contentRowId: nColumn.contentRowId,
          containerId: container.id,
          type,
          order: nColumn.order,
          movedContentBlockId: nColumn.movedContentBlockId,
          pageTemplateId
        },
        api: 1
      };
    }

  }

  getAddedColumnData(responseContainerData, columnId) {
    let columnData = null;
    some(responseContainerData.contentColumns, (eachColumnData) => {
      if (eachColumnData.id === columnId) {
        columnData = eachColumnData;
        return true;
      }
    });
    if (!columnData) {
      some(responseContainerData.contentColumns, (eachColumnData) => {
        columnData = this.getAddedColumnRowData(eachColumnData, columnId);
        if (columnData) {
          return true;
        }
      });
    }
    return columnData;
  }
  getAddedColumnRowData(responseContainerData, columnId) {
    let columnData = null;
    if (responseContainerData.contentRows) {
      some(responseContainerData.contentRows, (eachColumnData) => {
        columnData = this.getAddedColumnData(eachColumnData, columnId);
        if (columnData) {
          return true;
        }
      });
    }
    return columnData;
  }
}
